export default "__VITE_ASSET__BBQnUMa2__"